import { useMemo, type ReactElement } from 'react'
import { Tooltip } from '@mantine/core'
import { TButton } from 'app/components'

type Props = {
  isHiding: boolean
  onClick: (e: React.MouseEvent) => void
}
export const ButtonVisibility = ({ isHiding, onClick }: Props): ReactElement => {
  const label = useMemo(() => (isHiding ? 'Hiding child teams' : 'Showing child teams'), [isHiding])
  return (
    <Tooltip label={label}>
      <TButton buttonType='icon-rounded' icon={isHiding ? 'visibility_off' : 'visibility'} variant='gray' onClick={onClick} />
    </Tooltip>
  )
}
